import { useMemo } from 'react';
import { type SortDirection } from '@optimization/ssi-common';
import { type VehicleListColumnKey } from '../VehicleList';

export interface SortIndicator {
  columnKey: VehicleListColumnKey;
  sortingDirection: SortDirection;
}

interface UseSortIndicatorProperties {
  sortColumn?: VehicleListColumnKey | null;
  sortDirection: SortDirection;
}

const useSortIndicator = ({ sortColumn, sortDirection }: UseSortIndicatorProperties): SortIndicator | null =>
  useMemo(() => {
    if (!sortColumn) {
      return null;
    }

    return {
      columnKey: sortColumn,
      sortingDirection: sortDirection,
    };
  }, [sortColumn, sortDirection]);

export default useSortIndicator;
